import { Pipe, PipeTransform } from '@angular/core';
import { EntryType, OutlookEmail } from '@maximizer/outlook/shared/domain';

@Pipe({ name: 'outlookAvatarLetters' })
export class OutlookAvatarLettersPipe implements PipeTransform {
  transform(entry: OutlookEmail | null | undefined): string {
    if (!entry) return '';
    const { emailAddress, displayName, abentryType } = entry;

    // Contact display names may carry a " - Company" suffix (from search results).
    let name = displayName ?? '';
    if (abentryType === EntryType.Contact) {
      const separatorIndex = name.lastIndexOf(' - ');
      if (separatorIndex > -1) name = name.substring(0, separatorIndex);
    }
    name = name.trim();

    if (name) {
      const words = name.split(/\s+/).filter(Boolean);
      if (words.length > 1) {
        return (words[0][0] + words.at(-1)![0]).toUpperCase();
      }
      return words[0].substring(0, 2).toUpperCase(); // single word → first two letters
    }

    // No name → fall back to the email's first two characters.
    const local = emailAddress?.trim() ?? '';
    return local ? local.substring(0, 2).toUpperCase() : '';
  }
}
